export default "__VITE_ASSET__5f25906a__"